export default __webpack_public_path__ + "static/media/p1.317ef13e.jpg";